import React from 'react';
import { Box, Button, Modal, Paper, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import useCookieConsent from '../../hooks/useCookieConsent';
import CookiePreferencesDialog from './CookiePreferencesDialog';
import PrimaryActionButton from '../common/PrimaryActionButton';
import { BRAND, BRAND_RADIUS, brandAlpha } from '../../theme/brandTokens';
const modalPaperSx = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: { xs: 'calc(100% - 32px)', sm: 520 },
  maxWidth: '100%',
  maxHeight: { xs: 'calc(100dvh - 32px)', sm: '90vh' },
  overflowY: 'auto',
  p: { xs: 2.5, sm: 3 },
  borderRadius: BRAND_RADIUS.card,
  border: `1px solid ${BRAND.line}`,
  background: BRAND.surface,
  outline: 'none',
  boxShadow: `0 24px 48px ${brandAlpha('primaryDark', 0.18)}`,
};

const CookieConsentBanner = () => {
  const { t } = useTranslation();
  const {
    bannerOpen,
    acceptAll,
    rejectNonEssential,
    openPreferences,
  } = useCookieConsent();

  if (!bannerOpen) {
    return <CookiePreferencesDialog />;
  }

  return (
    <>
      <Modal
        open={bannerOpen}
        disableEscapeKeyDown
        disableScrollLock={false}
        aria-labelledby="cookie-consent-title"
        aria-describedby="cookie-consent-description"
      >
        <Paper elevation={0} sx={modalPaperSx}>
          <Typography id="cookie-consent-title" variant="h6" sx={{ fontWeight: 800, color: BRAND.text, mb: 1 }}>
            {t('legal.consent.bannerTitle')}
          </Typography>
          <Typography id="cookie-consent-description" variant="body2" color="text.secondary" sx={{ mb: 2.5, lineHeight: 1.6 }}>
            {t('legal.consent.bannerDescription')}
          </Typography>
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', sm: 'row' },
              gap: 1,
              justifyContent: 'flex-end',
            }}
          >
            <Button
              onClick={openPreferences}
              sx={{ textTransform: 'none', fontWeight: 600, color: BRAND.accentText }}
            >
              {t('legal.consent.customize')}
            </Button>
            <Button
              onClick={rejectNonEssential}
              sx={{ textTransform: 'none', fontWeight: 600, color: BRAND.accentText }}
            >
              {t('legal.consent.rejectNonEssential')}
            </Button>
            <PrimaryActionButton
              onClick={acceptAll}
              sx={{ textTransform: 'none' }}
            >
              {t('legal.consent.acceptAll')}
            </PrimaryActionButton>
          </Box>
        </Paper>
      </Modal>
      <CookiePreferencesDialog />
    </>
  );
};

export default CookieConsentBanner;
